<template>
  <v-container fluid class="handbook-dashboard-container">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card>
          <v-card-title>
            {{ isEdit ? 'Edit Handbook Category' : 'Create Handbook Category' }}
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                label="Category Name"
                v-model="categoryForm.name"
                :rules="[rules.required]"
                required
              ></v-text-field>
  
              <v-textarea
                label="Description"
                v-model="categoryForm.description"
              ></v-textarea>
              <!-- Removed the bar selection field -->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="submitCategory">
              {{ isEdit ? 'Save Changes' : 'Save Category' }}
            </v-btn>
            <v-btn text @click="cancel">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="isEdit" color="error" @click="deleteCategory">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
export default {
  name: 'HandbookCategoryForm',
  data() {
    return {
      valid: false,
      categoryForm: {
        name: '',
        description: '',
        // Do not include a bar field; backend sets it.
      },
      // (Optional) If you want to show the bar for information, you can do so via the root user.
      rules: {
        required: value => !!value || 'Required.'
      }
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
    isManager() {
      return (
        this.$root.user &&
        (this.$root.user.role === 'manager' || this.$root.user.role === 'supermanager')
      );
    }
  },
  created() {
    if (this.isEdit) {
      this.fetchCategory();
    }
  },
  methods: {
    fetchCategory() {
      const id = this.$route.params.id;
      axios.get(`/api/handbook-categories/${id}/`, { withCredentials: true })
        .then(res => {
          this.categoryForm = {
            name: res.data.name,
            description: res.data.description
          };
        })
        .catch(err => {
          console.error('Error fetching category:', err);
        });
    },
    submitCategory() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.isEdit) {
        const id = this.$route.params.id;
        axios.put(`/api/handbook-categories/${id}/`, this.categoryForm, { withCredentials: true })
          .then(() => {
            this.$router.push('/handbook');
          })
          .catch(err => {
            console.error('Error updating category:', err);
          });
      } else {
        axios.post(`/api/handbook-categories/`, this.categoryForm, { withCredentials: true })
          .then(() => {
            this.$router.push('/handbook');
          })
          .catch(err => {
            console.error('Error creating category:', err);
          });
      }
    },
    cancel() {
      this.$router.push('/handbook');
    },
    deleteCategory() {
      if (confirm(`Are you sure you want to delete the category "${this.categoryForm.name}"?`)) {
        const id = this.$route.params.id;
        axios.delete(`/api/handbook-categories/${id}/`, { withCredentials: true })
          .then(() => {
            this.$router.push('/handbook');
          })
          .catch(err => {
            console.error('Error deleting category:', err);
          });
      }
    }
  }
};
</script>

<style scoped>
.handbook-dashboard-container {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  min-height: 100vh;
  padding: 20px;
}
</style>